import React, { useEffect, useState } from 'react';
import { useStateContext } from '../contexts/ContextProvider';
import { usePost } from '../hooks/usePost';

const Signin = () => {
	const { setUser, currentColor } = useStateContext();
	const [formData, setFormData] = useState({
		email: '',
		password: ''
	});
	const [error, setError] = useState('');
	const { postRequest, loading, data, error: postError } = usePost()

	const handleInputChange = (e) => {
		const { name, value } = e.target;
		setFormData(prev => ({
			...prev,
			[name]: value
		}));
		setError('');
	};

	const onSignin = async (e) => {
		e.preventDefault();

		if (!formData.email || !formData.password) {
			setError('Veuillez remplir tous les champs');
			return;
		}

		postRequest('/users/login-dashboard', formData);
	}

	useEffect(() => {
		console.log(data)
		if (data) {
			setUser(data);
		}
	}, [data]);

	return (
		<div
			className='absolute top-0 left-0 right-0 bottom-0 flex justify-center items-center'
			style={{
				background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
				minHeight: '100vh',
			}}
		>
			<div
				className='bg-white dark:text-gray-500 dark:bg-secondary-dark-bg p-8 rounded-lg shadow-xl flex flex-col items-center'
				style={{
					width: '100%',
					maxWidth: '400px',
					animation: 'fade-in 0.5s ease-in-out',
				}}
			>
				<div className="mb-6 text-center">
					<h2 className='text-2xl font-bold mb-2 text-gray-800 dark:text-white'>Connexion</h2>
					<p className='text-sm text-gray-600 dark:text-gray-400'>
						Connectez-vous pour accéder au tableau de bord
					</p>
				</div>

				<form onSubmit={onSignin} className="w-full space-y-4">
					<div>
						<label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
							Email
						</label>
						<input
							type="email"
							name="email"
							value={formData.email}
							onChange={handleInputChange}
							className='w-full p-3 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white'
							placeholder='Votre adresse email'
							required
						/>
					</div>

					<div>
						<label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
							Mot de passe
						</label>
						<input
							type="password"
							name="password"
							value={formData.password}
							onChange={handleInputChange}
							className='w-full p-3 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white'
							placeholder='Votre mot de passe'
							required
						/>
					</div>

					<button
						type="submit"
						disabled={loading}
						className={`w-full p-3 text-white font-bold rounded transition-colors ${loading
							? 'bg-gray-400 cursor-not-allowed'
							: 'bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-300'
							}`}
						style={{
							backgroundColor: loading ? undefined : currentColor
						}}
					>
						{loading ? 'Connexion...' : 'Se connecter'}
					</button>
				</form>

				{error && (
					<div className='w-full mt-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded text-sm text-center'>
						{error}
					</div>
				)}
			</div>
		</div>
	);
};

export default Signin;